import { create } from 'zustand'
import type { ThemeType } from '@msb/shared'
import type { LoggerInstance } from '@msb/shared'

interface ThemeState {
  themeType: ThemeType
  logger?: LoggerInstance
  setTheme: (theme: ThemeType, trigger?: 'manual' | 'automatic') => void
  setLogger: (logger: LoggerInstance) => void
}

export const useThemeStore = create<ThemeState>()((set, get) => ({
  themeType: 'therapist',
  logger: undefined,

  setTheme: (themeType: ThemeType, trigger: 'manual' | 'automatic' = 'manual') => {
    const { themeType: previousTheme, logger } = get()

    if (previousTheme === themeType) {
      logger?.debug('Theme change ignored - same theme', {
        theme: themeType,
        action: 'theme_change_ignored',
        metadata: { trigger },
      });
      return;
    }

    // Log theme change
    if (logger) {
      logger.theme({
        previousTheme,
        newTheme: themeType,
        trigger,
        timestamp: Date.now(),
      });

      logger.info(`Theme changed: ${previousTheme} → ${themeType}`, {
        theme: themeType,
        action: 'theme_change',
        metadata: {
          previousTheme,
          trigger,
          source: 'setTheme',
        },
      });
    }

    set({ themeType })
  },

  setLogger: (logger: LoggerInstance) => {
    set({ logger });
    logger.debug('Logger attached to theme store', {
      component: 'ThemeStore',
      action: 'logger_attached',
    });
  },
}))
